import React from 'react';
import { Typography } from '@mui/material';
import { unauthorized } from '../assets/images/index';
import DeleteIcon from '../assets/images/deletePopup.svg';

interface UnauthorizedProps {
  requiredAccess?: React.ReactNode;
}

const Unauthorized: React.FC<UnauthorizedProps> = ({ requiredAccess }) => {
  return (
    <div className="unauthorized">
      <div className="unauthorized-image">
        <img src={unauthorized} alt="unauthorizedimage" />
      </div>
      <div className="unauthorized-text">
        <img src={DeleteIcon} alt={`Warning Icon`} width="32" />
        <Typography variant="h4">
          <b>Warning: Access Denied</b>
        </Typography>
        <Typography variant="body1">
          <b>You do not have permission to view this page.</b>
        </Typography>
        <Typography variant="body1">
          <b>Contact the site administrator for assistance.</b>
        </Typography>
        {requiredAccess && <>{requiredAccess}</>}
      </div>
    </div>
  );
};

export default Unauthorized;
